import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useMe } from "@/hooks/use-auth";
import { AuthLoading } from "./auth-loading";

/**
 * Guard for the /app (member) shell. Authenticates like RequireAuth, then
 * enforces the one-shell-per-role invariant: ADMIN and FULL_ACCESS live in the
 * /admin shell (see login.tsx post-login redirect), so if one of them lands on
 * /app/* — e.g. by typing/bookmarking a URL — we send them to the SAME path
 * under /admin, which registers the owner/manager routes the /app tree
 * intentionally omits (Users, Projects, Fields, Content Security, …). Without
 * this, a FULL_ACCESS user on /app/settings would see sidebar items whose
 * routes don't exist here and hit the error boundary. EDIT / EDIT_SHARE stay.
 */
export function RequireMemberShell() {
  const { data: me, isLoading } = useMe();
  const loc = useLocation();

  if (isLoading) return <AuthLoading />;
  if (!me) {
    const next = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (me.role === "ADMIN" || me.role === "FULL_ACCESS") {
    const adminPath = loc.pathname.replace(/^\/app(?=\/|$)/, "/admin");
    return <Navigate to={adminPath + loc.search} replace />;
  }
  return <Outlet />;
}
